export default "__VITE_ASSET__DvLOHGuj__"